module.exports = __webpack_public_path__ + "static/Group 6591-db93a7653a739a54d5622c907e030a14.png";